import type { ReactTable, RowData, TableFeatures } from '@tanstack/react-table';
import { useEffect } from 'react';

/**
 * Remeasures all columns when row density changes, data is loaded, or the column definition changes.
 * @internal
 */
export function useColumnRemeasure<
  TFeatures extends TableFeatures,
  TData extends RowData,
>(table: ReactTable<TFeatures, TData>): void {
  const rowDensity = table.atoms.visualVariantConfig?.get().rowDensity;
  const rowCount = table.getRowModel().rows.length;

  useEffect(() => {
    if (rowCount > 0) {
      table.remeasureAllColumns();
    }
    // Explicitly do not add the table instance here as it mutates too often.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowDensity, rowCount, table.optionsStore.state.columns]);
}
